var selectCaptcha = function selectCaptcha(state) {
  return state.captcha;
};
export var selectCaptchaRetryCount = function selectCaptchaRetryCount(state) {
  return selectCaptcha(state).retryCount;
};
export var selectCaptchaData = function selectCaptchaData(state) {
  return selectCaptcha(state).targetCaptchaData;
};
export var selectQueuedMessages = function selectQueuedMessages(state) {
  return selectCaptcha(state).queuedMessages;
};
export var selectValidateCaptchaStatus = function selectValidateCaptchaStatus(state) {
  return selectCaptcha(state).validateStatus;
};
export var selectCreateCaptchaStatus = function selectCreateCaptchaStatus(state) {
  return selectCaptcha(state).createStatus;
};
export var selectRecreateCount = function selectRecreateCount(state) {
  return selectCaptcha(state).recreateCount;
};
export var selectRecreateProcess = function selectRecreateProcess(state) {
  return selectCaptcha(state).recreateProcess;
};
export var selectCaptchaAccessToken = function selectCaptchaAccessToken(state) {
  return selectCaptcha(state).captchaAccessToken;
};
export var selectActiveCaptchaMessageId = function selectActiveCaptchaMessageId(state) {
  return selectCaptcha(state).activeCaptchaMessageId;
};